import { h, Fragment, Component } from 'preact';
import { observer } from 'mobx-react';

import { SortBy } from './SortBy';
import { SidebarContents } from './Sidebar';
import { IconClose } from '../Icons/IconClose';
import { IconFilters } from '../Icons/IconFilters';

import { Button, Slideout, withStore, FacetSlider, FacetListOptions, Icon } from '@searchspring/snap-preact-components';
import './Toolbar.css';

@withStore
@observer
export class Toolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: null,
      showViewResultsButton: false,
    };

    this.setActiveKey = this.setActiveKey.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.preventPropagation = this.preventPropagation.bind(this);
    this.handleCloseSidebar = this.handleCloseSidebar.bind(this);
    this.toggleViewResultsButton = this.toggleViewResultsButton.bind(this);
  }

  setActiveKey(value) {
    this.setState({
      activeKey: value,
    });
  }

  preventPropagation(e) {
    e.stopPropagation();
  }

  handleOutsideClick() {
    this.setState({
      activeKey: null,
    });
  }

  componentDidMount() {
    this.props.store.facets.forEach(facet => {
      facet.collapsed = true;
    });

    const toolbar = document.getElementById('toolbar-filters');
    const body = document.body;
    const sticky = toolbar.offsetTop;

    /* Handle sticky header */
    const toggle = () => {
      if (window.pageYOffset + 100 > sticky) {
        toolbar.classList.add('sticky');
        body.classList.add('show-header');
      } else {
        toolbar.classList.remove('sticky');
        body.classList.remove('show-header');
      }
    };
    window.onscroll = () => toggle();

    /* Handle outside click */
    toolbar.addEventListener('click', this.preventPropagation);
    window.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    /*Clean up event handlers */
    const toolbar = document.getElementById('toolbar-filters');
    toolbar.removeEventListener('click', this.preventPropagation);
    window.removeEventListener('click', this.handleOutsideClick);
  }

  handleCloseSidebar() {
    const mobileFiltersButton = document.querySelector('.show-filters-button');
    mobileFiltersButton.click();
  }

  toggleViewResultsButton() {
    this.setState({
      showViewResultsButton: !this.state.showViewResultsButton,
    });
  }

  render() {
    const inlineCount = this.props.store.data.merchandising?.content?.inline?.length ?? 0;
    const resultCount = this.props.store.data.pagination.totalResults - inlineCount;

    return (
      <>
        <div class='ss-toolbar__wrapper'>
          <div id='toolbar-filters' class='ss-toolbar ss-toolbar-top page-width'>
            <div class='ss-toolbar__result-count small-hide'>
              <span class='ss-toolbar__result-label'>
                {resultCount}
                {resultCount == 1
                  ? `${window.Resources.searchspring.searchHeader.result}`
                  : `${window.Resources.searchspring.searchHeader.results}`}
              </span>
            </div>

            <Slideout
              buttonContent={<SlideOutButton toggleViewResultsButton={this.toggleViewResultsButton} />}
              slideDirection='right'
              width='375px'
              overlayColor='rgba(0,0,0,0.5)'
            >
              <Fragment>
                <div class='slideout-content-wrapper slideout-filter-by'>
                  <div>{window.Resources.searchspring.filters.filterBy}</div>
                  <button class='link slideout-content-wrapper slideout-close-button' onClick={this.handleCloseSidebar}>
                    <IconClose />
                  </button>
                </div>
                <SidebarContents />
              </Fragment>
              <div class='slideout-view-results'>
                <button
                  class='button button--primary button--round button--small'
                  onClick={this.handleCloseSidebar}
                >{`${window.Resources.searchspring.filters.viewResults} (${resultCount})`}</button>
              </div>
            </Slideout>

            <div class='mobile-sort-by'>
              <SortBy activeKey={this.state.activeKey} setActiveKey={this.setActiveKey} />
            </div>
          </div>
        </div>

        <div class='ss-toolbar__result-count ss-toolbar__result-count--mobile medium-hide large-up-hide page-width'>
          <span class='ss-toolbar__result-label'>
            {resultCount}
            {resultCount == 1
              ? `${window.Resources.searchspring.searchHeader.result}`
              : `${window.Resources.searchspring.searchHeader.results}`}
          </span>
        </div>
      </>
    );
  }
}

class SlideOutButton extends Component {
  render({ toggleViewResultsButton }) {
    return (
      <button class='show-filters-button link' onClick={toggleViewResultsButton}>
        <span class='button-container'>
          <IconFilters />
          <Button>{window.Resources.searchspring.filters.filtersLabel}</Button>
        </span>
      </button>
    );
  }
}

export class OptionsSlot extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClick(e) {
    e.stopPropagation();
  }

  handleClose() {
    const { setActiveKey } = this.props;
    setActiveKey(null);
  }

  getFacetDisplay(facet) {
    switch (facet.display) {
      case 'slider':
        return <FacetSlider facet={facet} />;
      // case 'grid':
      //     return <FacetGridOptions facet={facet} values={facet.values} />
      // case 'palette':
      //     return <FacetPaletteOptions facet={facet} values={facet.values} />
      // case 'hierarchy':
      //     return <FacetHierarchyOptions values={facet.values} />
      default:
        return <FacetListOptions values={facet.values} />;
    }
  }

  render({ facet }) {
    const facetDisplay = this.getFacetDisplay(facet);

    return (
      <div onClick={this.handleClick}>
        {facetDisplay}
        <FacetOptionsFooter onClose={this.handleClose} />
      </div>
    );
  }
}
